import React from 'react';
import PropTypes from 'prop-types';

const PdpSharedBlurbGalleryAppointmentModal = React.lazy(() =>
    import(/* webpackChunkName: "PdpSharedBlurbGalleryAppointmentModalChunk" */ './PdpSharedBlurbGalleryAppointmentModal')
);

export function PdpSharedBlurbGalleryAppointmentModalLoader({
    environment,
    userId,
    itemId,
    onClose,
}) {
    return (
        <React.Suspense fallback={null}>
            <PdpSharedBlurbGalleryAppointmentModal
                environment={environment}
                userId={userId}
                itemId={itemId}
                onClose={onClose}
            />
        </React.Suspense>
    );
}

PdpSharedBlurbGalleryAppointmentModalLoader.propTypes = {
    environment: PropTypes.object,
    userId: PropTypes.string,
    onClose: PropTypes.function,
    itemId: PropTypes.string,
};
